<template>
  <div class="job-list">
    <!-- {{ jobs }} -->
    <div class="row">
      <div class="col col-8">
        <table class="table w-100">
          <thead>
            <tr class="th-items">
              <th
                @click="
                  orderLocation(
                    'location_floor',
                    locationFloorSort ? 'desc' : 'asc'
                  )
                "
              >
                Geschoss
                <span v-html="iconArrow"></span>
              </th>
              <th
                @click="
                  orderLocation(
                    'location_position',
                    locationPositionSort ? 'desc' : 'asc'
                  )
                "
              >
                Position
                <span v-html="iconArrow"></span>
              </th>
              <th>Service</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in jobsParts" v-bind:key="index">
              <td>{{ item.location_floor }}</td>
              <td>{{ item.location_position }}</td>
              <td>
                <p
                  v-for="(item2, index2) in item.job_part_pdf"
                  v-bind:key="index2"
                >
                  {{ formatDateMoment(item2.created_at) }} -
                  <a :href="'/users/' + item2.technician.id">{{
                    item2.technician.profile.firstname +
                    " " +
                    item2.technician.profile.lastname
                  }}</a>
                  <button
                    @click="
                      downloadWithVueResource(item2.pdf_url, index2, index)
                    "
                  >
                    <svg
                      width="1em"
                      height="1em"
                      viewBox="0 0 16 16"
                      class="bi bi-cloud-arrow-down"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z"
                      />
                      <path
                        fill-rule="evenodd"
                        d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708l2 2z"
                      />
                    </svg>
                  </button>
                </p>
              </td>
            </tr>

            <tr v-for="(item, index) in jobsPdfs" v-bind:key="index">
              <td>Alle Geschosse</td>
              <td>Alle Positionen</td>
              <td>
                {{ formatDateMoment(item.created_at) }}
                <button
                  @click="downloadWithVueResource(item.pdf_url, null, index)"
                >
                  <svg
                    width="1em"
                    height="1em"
                    viewBox="0 0 16 16"
                    class="bi bi-cloud-arrow-down"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z"
                    />
                    <path
                      fill-rule="evenodd"
                      d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708l2 2z"
                    />
                  </svg>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col col-4">
        <button @click="downloadAll" class="btn btn-primary">
          Alle aktuellen Serviceunterlagen downloaden
        </button>
        <!-- <button onclick="downloadPdf()">Download<button> -->
      </div>
    </div>
  </div>
</template>

<script>
import NeedsIcons from "../Mixins/NeedsIcons";
import NeedsTranslations from "../Mixins/NeedsTranslations";
import moment from "moment";

import Vue from "vue";
Vue.use(require("vue-resource"));
// import config from "../../plugins/";

export default {
  mixins: [NeedsIcons, NeedsTranslations],
  props: {
    dataUrl: {
      type: String,
    },
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    selected: {
      type: Number | Object,
    },
    headings: {
      type: Object,
      default() {
        return null;
      },
    },
    baseLinkUrl: {
      type: String,
    },
    getTechnicianUrl: {
      type: Function,
    },
    managerId: {
      type: Number,
    },
    editDateOnClick: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: true,
    },
    isFiltered: {
      type: Boolean,
      default: false,
    },
  },
  provide() {
    return {
      baseLinkUrl: this.baseLinkUrl,
      managerId: this.managerId,
      getTechnicianUrl: this.getTechnicianUrl,
    };
  },
  created() {
    if (this.dataUrl) {
      fetch(this.dataUrl)
        .then((res) => {
          return res.json();
        })
        .then((json) => {
          this.id_extern = json.data.id_extern;
          this.jobsPdfs = json.data.jobPdf;
          this.jobsParts = json.data.parts.filter(
            (x) => x.job_part_pdf.length > 0
          );
        });
    }
  },
  updated() {
    const selectedJobElement = this.$el.querySelector(
      ".job-list__item.selected"
    );

    if (selectedJobElement) {
      selectedJobElement.scrollIntoView();
    }
  },
  data() {
    return {
      locationPositionSort: false,
      locationFloorSort: false,
      id_extern: "",
      jobs: [],
      jobsParts: [],
      jobsPdfs: [],
      iconArrow:
        '<svg width="0.8em" height="0.8em" viewBox="0 0 16 16" class="bi bi-arrow-down-up" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"/></svg>',
    };
  },
  methods: {
    dynamicsort(property, order) {
      var sort_order = 1;
      if (order === "desc") {
        sort_order = -1;
      }
      return function (a, b) {
        if (a[property] < b[property]) {
          return -1 * sort_order;
        } else if (a[property] > b[property]) {
          return 1 * sort_order;
        } else {
          return 0 * sort_order;
        }
      };
    },

    orderLocation(location, type) {
      if (location == "location_floor") {
        this.locationFloorSort = !this.locationFloorSort;
      }
      if (location == "location_position") {
        this.locationPositionSort = !this.locationPositionSort;
      }
      this.jobsParts.sort(this.dynamicsort(location, type));
    },

    downloadAll() {
      for (let i = 0; i < this.jobsParts.length; i++) {
        // for (let j = 0; j < this.jobsParts[i].job_part_pdf.length; j++) {
          this.downloadWithVueResource(
            this.jobsParts[i].job_part_pdf[this.jobsParts[i].job_part_pdf.length - 1].pdf_url,
            this.jobsParts[i].job_part_pdf.length - 1,
            i
          );
        // }
      }
      for (let a = 0; a < this.jobsPdfs.length; a++) {
        this.downloadWithVueResource(
          this.jobsPdfs[a].pdf_url,
          null,
          a
        );
      }
    },

    formatDateMoment: function (date) {
      return moment(date, "YYYY.MM.DD HH:mm").format("DD.MM.YYYY HH:mm");
    },
    formatDateDownload: function (date) {
      return moment(date, "YYYY.MM.DD HH:mm").format("DDMMYYYY_HH-mm");
    },
    formatDate(date) {
      let newDate = new Date(date);
      var datestring =
        ((newDate.getDate() + "").length == 1
          ? "0" + newDate.getDate()
          : newDate.getDate()) +
        "." +
        ((newDate.getMonth() + 1 + "").length == 1
          ? "0" + (newDate.getMonth() + 1)
          : newDate.getMonth() + 1) +
        "." +
        newDate.getFullYear() +
        " " +
        newDate.getHours() +
        ":" +
        newDate.getMinutes();
      return datestring;
    },
    getDataNamePdf(i, j) {
      let name = "";
      if (j == null) {
        name =
          this.id_extern.replace(/\s/g, "") +
          "_" +
          this.formatDateDownload(this.jobsPdfs[i].created_at) +
          "_job_pdf";
        return name;
      }
      name =
        this.id_extern.replace(/\s/g, "") +
        "_" +
        this.formatDateDownload(this.jobsParts[i].job_part_pdf[j].created_at) +
        "_" +
        this.jobsParts[i].location_floor +
        this.jobsParts[i].location_position.replace(/\./g, "");
      return name;
    },
    downloadWithVueResource(path, index, startindex) {
      let url = this.baseLinkUrl + path;
      this.$http({
        method: "get",
        url: url,
        responseType: "arraybuffer",
      })
        .then((response) => {
          this.forceFileDownload(response, index, startindex);
        })
        .catch((error) => console.log("error occured" + error));
    },

    forceFileDownload(response, index, startindex) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        this.getDataNamePdf(startindex, index) + ".pdf"
      ); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
  },
};
</script>
<style lang="scss">
.th-items {
  background-color: black;
  color: white;

  th {
    text-align: inherit;
    border: 1px solid white;
    &:hover {
      cursor: pointer;
    }
    span {
      float: right;
    }
  }
}

table th,
td {
  padding: 0 10px;
}
table tbody tr:nth-child(even) {
  background-color: #f2f2f2;
  border-top: 1px solid #929191;
  border-bottom: 1px solid #929191;
}
</style>